import axios from "axios";

export default {
    getInvoiceSellers: async (company_id) => {
        const response = await axios.get(`/${company_id}/invoice_sellers`)
        return response.data
    },
    saveInvoiceSeller: async (company_id, payload) => {
        const invoice_seller_id = payload['id'] || 0
        return await axios.post(`/${company_id}/invoice_seller/${invoice_seller_id}`, payload)
    },
    archiveInvoiceSeller: async (company_id, invoice_seller_id) => {
        const response = await axios.patch(`/${company_id}/invoice_seller/${invoice_seller_id}/archive`)
        return response.data
    },
    restoreInvoiceSeller: async (company_id, invoice_seller_id) => {
        const response = await axios.patch(`/${company_id}/invoice_seller/${invoice_seller_id}/restore`)
        return response.data
    }

}